import { ReactElement, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Survey from '../components/survey/Survey'
import apiServices from '../libs/services'
import { LoadingSpinner } from '../components/atoms'

export const POST_SURVEY_ID_SLUG = 'iPOST_SURVEY'

function PostSurveyPage (): ReactElement {
  const navigate = useNavigate()
  const [surveyId, setSurveyId] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchSurveyMetadata = async (): Promise<void> => {
      try {
        const res = await apiServices.getSurveyByUserGeneratedId(POST_SURVEY_ID_SLUG)
        const id = res.data?.id as string | undefined
        if (id !== undefined && id !== null) {
          setSurveyId(id)
        } else {
          setError('Survey ID not found in response.')
        }
      } catch (err: any) {
        console.error('Failed to fetch survey metadata.', err)
        setError('Failed to load survey metadata.')
      } finally {
        setLoading(false)
      }
    }

    void fetchSurveyMetadata()
  }, [])

  const handleFinish = (): void => {
    navigate('/user-dashboard')
  }

  if (loading) {
    return (
      <div className='bg-dopage-black min-h-screen flex items-center justify-center'>
        <LoadingSpinner />
      </div>
    )
  }

  if (error !== null || surveyId === null) {
    return (
      <div className='bg-dopage-black min-h-screen flex items-center justify-center text-red-500 font-primary'>
        {error ?? 'An unexpected error occurred.'}
      </div>
    )
  }

  return <Survey surveyId={surveyId} onFinish={handleFinish} />
}

export default PostSurveyPage
